import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFilterStatus } from "../../redux/filter/actionCreator";
import BookCard from "./BookCard";

const Books = () => {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state.book);
  const {status, searchKeyword} = useSelector((state) => state.filter);


  let content; 
  
  if(books.length && status === "All"){
    content = books
    .map((book) => (
        <BookCard key={book.id} book={book} />
      ))
  }

  if(books.length && status === "All" && searchKeyword.length){
    content = books
    .filter((book) => book.name.toLowerCase().includes(searchKeyword.toLowerCase()))
    .map((book) => (
        <BookCard key={book.id} book={book} />
      ))
  }

 

  if(books.length && status === "featured"){
    content = books
    .filter((book) => book.featured === true)
    .map((book) => (
        <BookCard key={book.id} book={book} />
      )) 
  }

  if(books.length && status === "featured" && searchKeyword){
    content = books
    .filter((book) => book.featured === true)
    .filter((book) => book.name.toLowerCase().includes(searchKeyword.toLowerCase()))
    .map((book) => (
        <BookCard key={book.id} book={book} />
      )) 
  }


  return (
    <div className="order-2 xl:-order-1">
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>

        <div className="flex items-center space-x-4">
          <button className={`filter-btn ${status==="All" ? "active-filter" : ""}`} id="lws-filterAll" onClick={() => dispatch(changeFilterStatus("All"))}>
            All
          </button>
          <button className={`filter-btn ${status==="featured" ? "active-filter" : ""}`} id="lws-filterFeatured" onClick={() => dispatch(changeFilterStatus("featured"))}>
            Featured
          </button>
        </div>
      </div>
      <div className="lws-bookContainer">
        {content}
      </div>
    </div>
  );
};

export default Books;
